import { render, staticRenderFns } from "./phfilework.vue?vue&type=template&id=dca32dec"
import script from "./phfilework.vue?vue&type=script&lang=js"
export * from "./phfilework.vue?vue&type=script&lang=js"
import style0 from "./phfilework.vue?vue&type=style&index=0&id=dca32dec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports